import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";
import { useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import styled from "styled-components";
import { Link, NavLink } from "react-router-dom";

function Offcanvasnav() {
  const goToTopRef = useRef<null | HTMLDivElement>(null);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [handletransition, setTransition] = useState("500ms");
  // useEffect(() => {setTransition("500ms")}
  //   )

  return (
    <>
      <div ref={goToTopRef}></div>
      <div
        style={{
          height: "100%",
          minHeight: "100vh",
          position: "fixed",
          top: "calc(50vh - 8px)",
        }}
      >
        <Button
          variant="outline-dark"
          onClick={handleShow}
          style={{ verticalAlign: "middle" }}
        >
          <span className="menu-icon">{menuIcon}</span>
        </Button>
      </div>

      <StyledOffcanvas
        style={{ transition: handletransition }}
        onClick={() => {
          setTransition("500ms");
        }}
        show={show}
        onHide={handleClose}
      >
        <Offcanvas.Header closeButton closeVariant="white">
          <Offcanvas.Title>Menü</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Link
            to="/"
            style={{ textDecoration: "none" }}
            onClick={() => {
              if (goToTopRef.current) {
                goToTopRef.current.scrollIntoView({
                  behavior: "instant",
                  block: "end",
                });
              }
            }}
          >
            <StyledoffcanvasLink>
              <span style={{ color: "#b3b3b3" }}>Hauptseite</span>
            </StyledoffcanvasLink>
          </Link>

          <NavLink
            to="/appointments"
            style={{ textDecoration: "none" }}
            onClick={() => {
              if (goToTopRef.current) {
                goToTopRef.current.scrollIntoView({
                  behavior: "instant",
                  block: "end",
                });
              }
            }}
          >
            <StyledoffcanvasLink>
              <span style={{ color: "#b3b3b3" }}>Termine</span>
            </StyledoffcanvasLink>
          </NavLink>

          {/* <NavLink
            to="/gildefest"
            style={{ textDecoration: "none" }}
            onClick={() => {
              if (goToTopRef.current) {
                goToTopRef.current.scrollIntoView({
                  behavior: "instant",
                  block: "end",
                });
              }
            }}
          >
            <StyledoffcanvasLink>
              <span style={{ color: "#b3b3b3" }}>Gildefest</span>
            </StyledoffcanvasLink>
          </NavLink> */}

          <NavLink
            to="/impressum"
            style={{ textDecoration: "none" }}
            onClick={() => {
              if (goToTopRef.current) {
                goToTopRef.current.scrollIntoView({
                  behavior: "instant",
                  block: "end",
                });
              }
            }}
          >
            <StyledoffcanvasLink>
              <span style={{ color: "#b3b3b3" }}>Impressum</span>
            </StyledoffcanvasLink>
          </NavLink>
        </Offcanvas.Body>
      </StyledOffcanvas>
    </>
  );
}

export default Offcanvasnav;

const menuIcon = <FontAwesomeIcon icon={faAnglesRight} />;

const StyledOffcanvas = styled(Offcanvas).attrs({ variant: "dark" })`
  background-color: #212529;
  color: #b3b3b3;
  .styledoffcanvas-title {
    color: white;
  }
`;

const StyledoffcanvasLink = styled.div`
  font-size: 20px;
  padding: 15px 5px;
  border-bottom: 1px solid grey;
  background-color: #212529;
  color: white;
  &:hover {
    cursor: pointer;
    background-color: #92919125;
  }
`;
